export default "__VITE_ASSET__6kQ$Vi8a__"